import React, { useState, useMemo } from "react";
import classnames from "classnames";
import { Input } from '../../../Input';
import { SearchIcon } from '../../../../icons/Search';
import { Checkbox } from '../../../Checkbox/Checkbox';
import "./SearchList.scss";

export function SearchList({ list, selected, onChange }){
  const [search, setSearch] = useState('');
  const filteredList = useMemo(() => {
    if(!search){
      return list;
    }

    return list.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()));
  }, [list, search]);

  function handleChangeSearch(e) {
    setSearch(e.target.value);
  }

    function toggleSelect(value) {
      const selectedResult = selected.includes(value)
        ? selected.filter((selectedItem) => selectedItem !== value)
        : selected.concat(value);

      onChange(selectedResult);
    }

  return (
    <div className="SearchList">
      <div className="SearchList__search">
        <Input
          prefix={<SearchIcon color="#8898AE"/>}
          placeholder="Search..."
          value={search}
          onChange={handleChangeSearch}
        />
      </div>

      {filteredList.length > 0 && (
        <div className="SearchList__select">
          <ul className="SearchList__list">
            {filteredList.map((item) => {
              const isSelected = selected.includes(item.value);

              return (
                <li
                  className={classnames("SearchList__list-item", {
                    "SearchList__list-item_selected": isSelected
                  })}
                  onClick={() => toggleSelect(item.value)}
                  key={item.value}
                >
                  {item.image && (
                    <img src={item.image} alt="" className="SearchList__list-item-image" />
                  )}
                  <span className="SearchList__list-item-name" dangerouslySetInnerHTML={{ __html: item.name }} />
                  {isSelected && (
                    <Checkbox round checked={isSelected} className="SearchList__list-item-checkbox" />
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
